<template>
  <user-manager
    v-bind:context="'admin'"
    v-bind:functionalRoles="functionalRoles"
  />
</template>

<script>
import UserManager from '@/components/UserManager'

export default {
  name: "AdminUserManager",
  components: {
    UserManager
  },
  computed: {
    functionalRoles () {
      return [
        this.getExpression('FunctionalRole', 'Admin'),
        this.getExpression('FunctionalRole', 'DomainManager'),
        this.getExpression('FunctionalRole', 'KioskManager'),
        this.getExpression('FunctionalRole', 'FamilyFacilitator'),
        this.getExpression('FunctionalRole', 'VirtualVisitor')
      ]
    }
  }
}
</script>